import { useMemo } from 'react'
import { withStyles } from '@aura/components/styles'
import Box from '@aura/components/box'
import Grid from '@aura/components/grid'
import Link from '@aura/components/link'
import Typography from '@aura/components/typography'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import { getCurrentYear } from '../../utils/datetime'
import styles from './styles'


const Component = ({
    applicationContext,
    classes,
}) => {
    const { t: translate } = useTranslation()

    const currentYear = useMemo(() => getCurrentYear(), [])

    return (<Grid container className={classes.footerRoot} direction='column'>
        <Grid className={classes.footerContainer}>
            <Grid className={classes.verbiageContainer}>
                <Typography className={classes.text}> {translate(applicationContext?.privacyText)}
                    <Link className={classes.link} href={translate(applicationContext?.privacyLink)} underline="none" target="_blank" rel="noopener noreferrer">
                        {translate(applicationContext?.privacyPolicy)}
                    </Link> {translate(applicationContext?.wrapperText)} <Link className={classes.link} href={translate(applicationContext?.termsConditionsUrl)} underline="none" target="_blank" rel="noopener noreferrer">
                        {translate(applicationContext?.termsConditions)}
                    </Link>
                </Typography>
            </Grid>
            <Box component="div" className={classes.orDivider} >
                <Box component="div" className={classes.innerOr}>{translate('or')}</Box>
            </Box>
            <Grid className={classes.verbiageContainer}>
                <Typography className={classes.text}>{translate(applicationContext?.footerVerbiage)}</Typography>
            </Grid>

            <Grid className={classes.verbiageContainer}>
                <Typography className={classes.text}>{currentYear} {translate(applicationContext?.footerCopyright)}</Typography>
            </Grid>
        </Grid>
    </Grid>)
}
Component.propTypes = {
    classes: PropTypes.object.isRequired
}

export default withStyles(Component, styles)
